/**
 * Discord band starfield (pick "7" from the motion previews).
 *
 * A canvas of slowly rising stars behind the band's copy, a few in the brand
 * purple, leaning away from the pointer. Drawn only while the band is on
 * screen and the tab is visible; with reduced motion the stars are drawn
 * once and stay still.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(band) {
    if (band.dataset.stars) return;
    band.dataset.stars = 'true';
    var canvas = document.createElement('canvas');
    canvas.className = 'discord-cta__stars';
    canvas.setAttribute('aria-hidden', 'true');
    var inner = band.querySelector('.discord-cta__inner');
    band.insertBefore(canvas, inner || null);
    var ctx = canvas.getContext('2d');
    var stars = [];
    var mx = 0;
    var my = 0;
    var running = false;
    var raf = 0;
    var brand = getComputedStyle(band).getPropertyValue('--color-brand').trim() || '#a97ee0';

    for (var i = 0; i < 110; i++) {
      stars.push({ x: Math.random(), y: Math.random(), z: Math.random() * 0.8 + 0.2, v: Math.random() * 0.00022 + 0.00005, b: Math.random() < 0.22 });
    }

    function size() {
      var r = canvas.getBoundingClientRect();
      var d = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, r.width * d);
      canvas.height = Math.max(1, r.height * d);
      ctx.setTransform(d, 0, 0, d, 0, 0);
    }

    function draw() {
      var w = canvas.clientWidth;
      var h = canvas.clientHeight;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        if (!reduce.matches) {
          s.y -= s.v * s.z * 6;
          if (s.y < 0) { s.y = 1; s.x = Math.random(); }
        }
        var x = (s.x - mx * 0.05 * s.z) * w;
        var y = (s.y - my * 0.05 * s.z) * h;
        ctx.globalAlpha = s.b ? s.z : s.z * 0.75;
        ctx.fillStyle = s.b ? brand : '#f1f1f3';
        ctx.beginPath();
        ctx.arc(x, y, s.z * 1.6, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (running && !reduce.matches) raf = window.requestAnimationFrame(draw);
    }

    function start() {
      if (running) return;
      running = true;
      size();
      raf = window.requestAnimationFrame(draw);
    }
    function stop() {
      running = false;
      window.cancelAnimationFrame(raf);
    }

    band.addEventListener('pointermove', function (e) {
      var b = band.getBoundingClientRect();
      mx = (e.clientX - b.left) / b.width - 0.5;
      my = (e.clientY - b.top) / b.height - 0.5;
    });
    window.addEventListener('resize', function () { size(); if (!running) draw(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) start();
        else stop();
      }).observe(band);
    } else {
      start();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
    });
    size();
    draw();
  }

  function init(root) {
    (root || document).querySelectorAll('.discord-cta').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
